import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class RecoveryService {

constructor(private http: HttpClient) { }

baseUrl: string = "https://"+environment.apiUrl+"/api/recovery/";

recovery(email: string) {
  return this.http.post(this.baseUrl, {email: email}).pipe();
}

chanllenge(cha: string) {
  return this.http.post(this.baseUrl+"confirm", {cha: cha}).pipe(
    map((data: any) => {
      return data.result;
    })
  );
}

password(id: number, password: string) {
  return this.http.post(this.baseUrl+"password",{id: id,password: password}).pipe();
}

}
